import React from 'react';
import PropTypes from 'prop-types';
import NavigationComponent from 'src/components/navigation-component/NavigationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import { DEFAULT_DP } from 'src/constants/CommonConstants';
import { logoutAction } from '../auth-container/actions/AuthActions';

const menus = [

    {
        title: 'Internal',
        scope: '',
        items: [
            {
                faIcon: 'fa-user-alt',
                title: 'DashBoard',
                scope: '',
                items: [
                    {
                        title: 'Dashboard',
                        scope: '',
                        link: '/',
                    },
                ],
            },
            {
                faIcon: 'fa-user-alt',
                title: 'People',
                scope: 'people',
                items: [
                    {
                        title: 'User Manager',
                        scope: 'people.user_manager',
                        link: '/user/manage',
                    },
                    {
                        title: 'Role Manager',
                        scope: 'people.role_manager',
                        link: '/permissions/role',
                    },
                ],
            },
            {
                faIcon: 'fa-city',
                title: 'Masters',
                scope: 'master',
                items: [
                    {
                        title: 'City Manager',
                        scope: 'master.city_manager',
                        link: '/city/manage',
                    },
                    {
                        title: 'Area Manager',
                        scope: 'master.area_manager',
                        link: '/area/manage',
                    },
                    {
                        title: 'Company Manager',
                        scope: 'master.company_manager',
                        link: '/company/manage',
                    },
                    {
                        title: 'Product Manager',
                        scope: 'master.product_manager',
                        link: '/product/manage',
                    },
                    {
                        title: 'Single Field Masters',
                        scope: 'master.product_manager',
                        link: '/masters/manage',
                    },
                    {
                        title: 'Customer Manager',
                        scope: 'master.customer_manager',
                        link: '/customer/manage',
                    },
                    {
                        title: 'Catalogue Manager',
                        scope: 'master.catalogue_manager',
                        link: '/catalogue/manage',
                    },
                    {
                        title: 'Commission Manager',
                        scope: 'master.commission_manager',
                        link: '/commission/manage',
                    },
                     {
                        title: 'Team Target',
                        scope: 'master.target_manager',
                        link: '/teamTarget/manage',
                    },
                    {
                        title: 'Insurance slab Manager',
                        scope: 'master.insurance_slab_manager',
                        link: '/insurance-slab/manage',
                    },
                    // {
                    //     title: 'Agent Commission Mgr',
                    //     scope: 'master.agent_commission_manager',
                    //     link: '/agentcommission/manage'
                    // },
                ],
            },
            {
                faIcon: 'fa-project-diagram',
                title: 'Flow',
                scope: 'flow',
                items: [
                    {
                        title: 'Case Manager',
                        scope: 'flow.case_manager',
                        link: '/case/manage',
                    },
                    {
                        title: 'Wallet Manager',
                        scope: 'wallet.wallet_manager',
                        link: '/wallet/manage',
                    },
                ],
            },
            {
                faIcon: 'fa-file',
                title: 'Reports',
                scope: 'reports',
                items: [
                    {
                        title: 'Car Loan Payout Calculation',
                        scope: 'reports.account_payoutCal',
                        link: '/reports/account-Payout',
                    },
                    {
                        title: 'Insurance Payout Calculation',
                        scope: 'reports.account_insurance_payout',
                        link: '/reports/account-insurance-payout',
                    },
                    {
                        title: 'Admin Car Loan Payout',
                        scope: 'reports.payout_calculation',
                        link: '/reports/payout-calculation',
                    },
                    {
                        title: 'Admin Insurance Payout',
                        scope: 'reports.insurance_payout',
                        link: '/reports/insurance-payout',
                    },
                    {
                        title: 'Case List',
                        scope: 'reports.case_list',
                        link: '/reports/case-list',
                    },
                    {
                        title: 'Insurance Report',
                        scope: 'reports.insurance_list',
                        link: '/reports/insurance-report',
                    },
                    {
                        title: 'Insurance Renewal Alert',
                        scope: 'reports.insurance_alert_list',
                        link: '/reports/insurance-renewal-alert',
                    },
                    {
                        title: 'RC PDD Report',
                        scope: 'reports.rc_pdd_report',
                        link: '/reports/rc-pdd-report',
                    },
                    {
                        title: 'RTO Report',
                        scope: 'reports.RTO_report',
                        link: '/reports/RTO-report',
                    },
                    {
                        title: 'Advance and Expense Report',
                        scope: 'reports.advance_expense_report',
                        link: '/reports/advance-expense-report',
                    },
                    {
                        title: 'Sales Report',
                        scope: 'reports.sales_report',
                        link: '/reports/sales-report',
                    },
                    {
                        title: 'Back End Manager Sales Report',
                        scope: 'reports.back_end_manager_sales_report',
                        link: '/reports/back-end-manager-sales-report',
                    },
                ],
            },
            // {
            //     faIcon: 'fa-user-alt',
            //     title: 'Wallet',
            //     scope: 'wallet',
            //     items: [
            //         {
            //             title: 'Wallet Manager',
            //             scope: 'wallet.wallet_manager',
            //             link: '/wallet/manage',
            //         },
            //     ],
            // },
        ],
    },
];

const NavigationContainer = ({ closeSideBar, openSideBar }) => {
    const dispatch = useDispatch();

    const { personalInfo, userType, profilePicUrl } = useSelector(
        (state) => state.AuthReducer,
        shallowEqual,
    );
    const logout = () => dispatch(logoutAction());

    return (
        <NavigationComponent
            closeSideBar={closeSideBar}
            openSideBar={openSideBar}
            heading="LOI"
            menus={menus}
            logout={logout}
            personalInfo={personalInfo}
            userType={userType}
            profilePicUrl={profilePicUrl || DEFAULT_DP}
        />
    );
};

NavigationContainer.propTypes = {
    closeSideBar: PropTypes.func.isRequired,
    openSideBar: PropTypes.func.isRequired,
};

export default NavigationContainer;
